import axios from 'axios';

const adminUrl = process.env.VUE_APP_ADMIN_URL;

export default class CargasMasivasService {
  static getToken() {
    return JSON.parse(localStorage.getItem('accessToken'));
  }

  static async _readSSEStream(response, { onProgress, onDone, onError } = {}) {
    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';
    let finalData = null;

    let chunk = await reader.read();
    while (!chunk.done) {
      buffer += decoder.decode(chunk.value, { stream: true });
      const lines = buffer.split('\n');
      buffer = lines.pop();
      for (const line of lines) {
        if (!line.startsWith('data: ')) continue;
        let event;
        try {
          event = JSON.parse(line.slice(6));
        } catch {
          continue; // línea malformada, ignorar
        }
        if (event.type === 'progress') onProgress?.(event);
        else if (event.type === 'done') { finalData = event.data; onDone?.(event.data); }
        else if (event.type === 'error') onError?.(event);
      }
      chunk = await reader.read();
    }
    return finalData;
  }

  static async bulkAltas(payload, callbacks = {}) {
    try {
      const response = await fetch(`${adminUrl}/companies/users/bulk`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${this.getToken()}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        console.error('[CargasMasivas] bulkAltas error:', err);
        return { status: 'error' };
      }
      const data = await this._readSSEStream(response, callbacks);
      return data ? { status: 'ok', data } : { status: 'error' };
    } catch (err) {
      console.error('[CargasMasivas] bulkAltas:', err.message);
      return { status: 'error' };
    }
  }

  static async bulkBajas(payload, callbacks = {}) {
    try {
      const response = await fetch(`${adminUrl}/companies/users/bulk-deactivate`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${this.getToken()}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        console.error('[CargasMasivas] bulkBajas error:', err);
        return { status: 'error' };
      }
      const data = await this._readSSEStream(response, callbacks);
      return data ? { status: 'ok', data } : { status: 'error' };
    } catch (err) {
      console.error('[CargasMasivas] bulkBajas:', err.message);
      return { status: 'error' };
    }
  }

  static async nominaDiff(payload) {
    try {
      const response = await axios.post(`${adminUrl}/companies/users/nomina-diff`, payload, {
        headers: { Authorization: `Bearer ${this.getToken()}` },
      });
      if (response.data.status === 'ok') {
        return { status: 'ok', data: response.data.data };
      }
      return { status: 'error' };
    } catch (err) {
      console.error('[CargasMasivas] nominaDiff:', err?.response?.data || err.message);
      return { status: 'error' };
    }
  }
}
